// extracted by mini-css-extract-plugin
export default {"main_container":"AppContainer_main_container__z8nYf","content":"AppContainer_content__zBlHD","footer":"AppContainer_footer__Kg6c-"};